// PREMIUM NATURE SCROLL ANIMATIONS - WITH PIT CLUB REVEAL

if (typeof gsap !== 'undefined' && typeof ScrollTrigger !== 'undefined') {
  gsap.registerPlugin(ScrollTrigger);

  const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  if (!prefersReducedMotion) {
    // ===== HERO NATURE SCROLL =====
    const heroSection = document.querySelector('.hero-nature-scroll__sticky');
    if (heroSection) {
      const plants = document.querySelectorAll('.hero-nature-scroll__plant');
      const productReveals = document.querySelectorAll('.hero-nature-scroll__product');
      const pitClubReveal = document.querySelector('[data-pit-club-reveal]');
      const scrollCue = document.querySelector('.hero-nature-scroll__scroll-cue');

      // Plant fade out on scroll
      plants.forEach((plant) => {
        gsap.to(plant, {
          opacity: 0,
          duration: 2,
          ease: 'power2.inOut',
          scrollTrigger: {
            trigger: '.hero-nature-scroll',
            start: 'top top',
            end: 'bottom top',
            scrub: 1.5,
            markers: false,
          },
        });
      });

      // Product reveals as plants fade
      productReveals.forEach((product, index) => {
        gsap.to(product, {
          opacity: 1,
          duration: 2,
          ease: 'power2.inOut',
          delay: index * 0.3,
          scrollTrigger: {
            trigger: '.hero-nature-scroll',
            start: 'top top',
            end: 'bottom top',
            scrub: 1.5,
            markers: false,
          },
        });
      });

      // Pit Club info reveal after product
      if (pitClubReveal) {
        gsap.to(pitClubReveal, {
          opacity: 1,
          duration: 1.5,
          delay: 0.8,
          ease: 'power2.out',
          scrollTrigger: {
            trigger: '.hero-nature-scroll',
            start: 'top top',
            end: 'bottom top',
            scrub: 1.5,
            markers: false,
          },
        });
      }

      // Scroll cue fade after scroll starts
      gsap.to(scrollCue, {
        opacity: 0,
        pointerEvents: 'none',
        duration: 0.6,
        scrollTrigger: {
          trigger: '.hero-nature-scroll',
          start: 'top center',
          end: 'top 300px',
          scrub: 0.5,
        },
      });

      // Content scale up on scroll
      const content = document.querySelector('.hero-nature-scroll__content');
      if (content) {
        gsap.from(content, {
          scale: 0.95,
          opacity: 0.8,
          duration: 1.5,
          ease: 'back.out',
          scrollTrigger: {
            trigger: '.hero-nature-scroll__sticky',
            start: 'top top',
            end: 'center top',
            scrub: 1,
            markers: false,
          },
        });
      }
    }

    // ===== PRODUCT CARD REVEALS =====
    const productCards = document.querySelectorAll('.product-card');
    productCards.forEach((card, index) => {
      gsap.from(card, {
        opacity: 0,
        y: 60,
        duration: 0.8,
        delay: index * 0.1,
        ease: 'power3.out',
        scrollTrigger: {
          trigger: card,
          start: 'top 80%',
          end: 'top 50%',
          scrub: false,
          markers: false,
        },
      });
    });

    // ===== HEADING REVEALS =====
    const headings = document.querySelectorAll('[data-scroll-reveal-heading]');
    headings.forEach((heading) => {
      gsap.from(heading, {
        opacity: 0,
        y: 40,
        duration: 1,
        ease: 'power3.out',
        scrollTrigger: {
          trigger: heading,
          start: 'top 85%',
          end: 'top 55%',
          scrub: false,
          markers: false,
        },
      });
    });

    // ===== STAT CARD REVEALS =====
    const statCards = document.querySelectorAll('.stat-card');
    statCards.forEach((card, index) => {
      gsap.from(card, {
        opacity: 0,
        y: 40,
        duration: 0.8,
        delay: index * 0.1,
        ease: 'power3.out',
        scrollTrigger: {
          trigger: card,
          start: 'top 85%',
          end: 'top 55%',
          scrub: false,
          markers: false,
        },
      });
    });

    // ===== PARALLAX BACKGROUNDS =====
    const parallaxElements = document.querySelectorAll('[data-parallax-bg]');
    parallaxElements.forEach((element) => {
      gsap.to(element, {
        y: (index) => -index * 80,
        ease: 'none',
        scrollTrigger: {
          trigger: element,
          start: 'top center',
          end: 'bottom center',
          scrub: 1,
          markers: false,
        },
      });
    });
  }

  // ===== SMOOTH SCROLL ANCHORS =====
  const links = document.querySelectorAll('a[href^="#"]');
  links.forEach((link) => {
    link.addEventListener('click', (e) => {
      const target = document.querySelector(link.getAttribute('href'));
      if (target) {
        e.preventDefault();
        gsap.to(window, {
          scrollTo: { y: target, offsetY: 100 },
          duration: 1.2,
          ease: 'power2.inOut',
        });
      }
    });
  });
}

// ===== INTERSECTION OBSERVER FOR LAZY REVEALS =====
if ('IntersectionObserver' in window) {
  const revealElements = document.querySelectorAll('[data-reveal-on-scroll]');
  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('reveal-on-scroll');
          observer.unobserve(entry.target);
        }
      });
    },
    { threshold: 0.1 }
  );

  revealElements.forEach((element) => {
    observer.observe(element);
  });
}
